export var isLinkFrodor = function (href) {
    return /https?:\/\/artists.spotify.com(\/.*)?$/.test(href);
};
